// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as authRouteRouteImport } from './routes/(auth)/route'
import { Route as privateRouteRouteImport } from './routes/(private)/route'
import { Route as privateIndexRouteImport } from './routes/(private)/index'
import { Route as privateAssistenzaRouteRouteImport } from './routes/(private)/assistenza/route'
import { Route as privateBandiRouteRouteImport } from './routes/(private)/bandi/route'
import { Route as privateBandoRouteRouteImport } from './routes/(private)/bando/route'
import { Route as privateEmailTextsRouteRouteImport } from './routes/(private)/email-texts/route'
import { Route as privateExportsRouteRouteImport } from './routes/(private)/exports/route'
import { Route as privateInviiRouteRouteImport } from './routes/(private)/invii/route'
import { Route as privateResidencesRouteRouteImport } from './routes/(private)/residences/route'
import { Route as privateStruttureRouteRouteImport } from './routes/(private)/strutture/route'
import { Route as privateUsersRouteRouteImport } from './routes/(private)/users/route'
import { Route as authAcceptInviteIndexRouteImport } from './routes/(auth)/accept-invite/index'
import { Route as authForgotPasswordIndexRouteImport } from './routes/(auth)/forgot-password/index'
import { Route as authLoginIndexRouteImport } from './routes/(auth)/login/index'
import { Route as authResetPasswordIndexRouteImport } from './routes/(auth)/reset-password/index'
import { Route as privateAdminsIndexRouteImport } from './routes/(private)/admins/index'
import { Route as privateAssistenzaIndexRouteImport } from './routes/(private)/assistenza/index'
import { Route as privateBandiIndexRouteImport } from './routes/(private)/bandi/index'
import { Route as privateBandoIndexRouteImport } from './routes/(private)/bando/index'
import { Route as privateBandoResidenceIdRouteRouteImport } from './routes/(private)/bando/$residenceId/route'
import { Route as privateEmailTextsIndexRouteImport } from './routes/(private)/email-texts/index'
import { Route as privateExportsIndexRouteImport } from './routes/(private)/exports/index'
import { Route as privateInviiIndexRouteImport } from './routes/(private)/invii/index'
import { Route as privateProfileIndexRouteImport } from './routes/(private)/profile/index'
import { Route as privateResidencesIndexRouteImport } from './routes/(private)/residences/index'
import { Route as privateStruttureIndexRouteImport } from './routes/(private)/strutture/index'
import { Route as privateStruttureResidenceIdRouteRouteImport } from './routes/(private)/strutture/$residenceId/route'
import { Route as privateUsersIndexRouteImport } from './routes/(private)/users/index'
import { Route as privateAssistenzaUserIdIndexRouteImport } from './routes/(private)/assistenza/$userId/index'
import { Route as privateBandoResidenceIdIndexRouteImport } from './routes/(private)/bando/$residenceId/index'
import { Route as privateBandoResidenceIdAttivitaRouteRouteImport } from './routes/(private)/bando/$residenceId/attivita/route'
import { Route as privateBandoResidenceIdDomandeRouteRouteImport } from './routes/(private)/bando/$residenceId/domande/route'
import { Route as privateBandoResidenceIdGraduatoriaRouteRouteImport } from './routes/(private)/bando/$residenceId/graduatoria/route'
import { Route as privateBandoResidenceIdOfferteRouteRouteImport } from './routes/(private)/bando/$residenceId/offerte/route'
import { Route as privateBandoResidenceIdSegnalazioniRouteRouteImport } from './routes/(private)/bando/$residenceId/segnalazioni/route'
import { Route as privateBandoResidenceIdVerificheRouteRouteImport } from './routes/(private)/bando/$residenceId/verifiche/route'
import { Route as privateEmailTextsCodeIndexRouteImport } from './routes/(private)/email-texts/$code/index'
import { Route as privateExportsIdIndexRouteImport } from './routes/(private)/exports/$id/index'
import { Route as privateInviiAnomalyIdIndexRouteImport } from './routes/(private)/invii/$anomalyId/index'
import { Route as privateResidencesResidenceIdIndexRouteImport } from './routes/(private)/residences/$residenceId/index'
import { Route as privateResidencesNewIndexRouteImport } from './routes/(private)/residences/new/index'
import { Route as privateStruttureResidenceIdIndexRouteImport } from './routes/(private)/strutture/$residenceId/index'
import { Route as privateUsersUserIdIndexRouteImport } from './routes/(private)/users/$userId/index'
import { Route as privateBandiResidenceIdClassificaIndexRouteImport } from './routes/(private)/bandi/$residenceId/classifica/index'
import { Route as privateBandiResidenceIdQuotaDsuIndexRouteImport } from './routes/(private)/bandi/$residenceId/quota-dsu/index'
import { Route as privateBandoResidenceIdAttivitaIndexRouteImport } from './routes/(private)/bando/$residenceId/attivita/index'
import { Route as privateBandoResidenceIdDomandeIndexRouteImport } from './routes/(private)/bando/$residenceId/domande/index'
import { Route as privateBandoResidenceIdDomandeSubmissionIdRouteRouteImport } from './routes/(private)/bando/$residenceId/domande/$submissionId/route'
import { Route as privateBandoResidenceIdGraduatoriaIndexRouteImport } from './routes/(private)/bando/$residenceId/graduatoria/index'
import { Route as privateBandoResidenceIdGraduatoriaSegnalazioniRouteRouteImport } from './routes/(private)/bando/$residenceId/graduatoria/segnalazioni/route'
import { Route as privateBandoResidenceIdIngressiIndexRouteImport } from './routes/(private)/bando/$residenceId/ingressi/index'
import { Route as privateBandoResidenceIdOfferteIndexRouteImport } from './routes/(private)/bando/$residenceId/offerte/index'
import { Route as privateBandoResidenceIdQuotaDsuIndexRouteImport } from './routes/(private)/bando/$residenceId/quota-dsu/index'
import { Route as privateBandoResidenceIdSegnalazioniIndexRouteImport } from './routes/(private)/bando/$residenceId/segnalazioni/index'
import { Route as privateBandoResidenceIdVerificheIndexRouteImport } from './routes/(private)/bando/$residenceId/verifiche/index'
import { Route as privateBandoResidenceIdAttivitaQuotaDsuIndexRouteImport } from './routes/(private)/bando/$residenceId/attivita/quota-dsu/index'
import { Route as privateBandoResidenceIdDomandeSubmissionIdIndexRouteImport } from './routes/(private)/bando/$residenceId/domande/$submissionId/index'
import { Route as privateBandoResidenceIdDomandeCaricaIndexRouteImport } from './routes/(private)/bando/$residenceId/domande/carica/index'
import { Route as privateBandoResidenceIdGraduatoriaSegnalazioniIndexRouteImport } from './routes/(private)/bando/$residenceId/graduatoria/segnalazioni/index'
import { Route as privateBandoResidenceIdOfferteDecadenzeIndexRouteImport } from './routes/(private)/bando/$residenceId/offerte/decadenze/index'
import { Route as privateBandoResidenceIdSegnalazioniFlagIdIndexRouteImport } from './routes/(private)/bando/$residenceId/segnalazioni/$flagId/index'
import { Route as privateBandoResidenceIdVerificheVerificationIdIndexRouteImport } from './routes/(private)/bando/$residenceId/verifiche/$verificationId/index'
import { Route as privateBandoResidenceIdDomandeSubmissionIdCorreggiIndexRouteImport } from './routes/(private)/bando/$residenceId/domande/$submissionId/correggi/index'
import { Route as privateBandoResidenceIdGraduatoriaSegnalazioniReportIdIndexRouteImport } from './routes/(private)/bando/$residenceId/graduatoria/segnalazioni/$reportId/index'

const authRouteRoute = authRouteRouteImport.update({
            id: '/(auth)',getParentRoute: () => rootRouteImport
          })
const privateRouteRoute = privateRouteRouteImport.update({
            id: '/(private)',getParentRoute: () => rootRouteImport
          })
const privateIndexRoute = privateIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateRouteRoute
          })
const privateAssistenzaRouteRoute = privateAssistenzaRouteRouteImport.update({
            id: '/assistenza',path: '/assistenza',getParentRoute: () => privateRouteRoute
          })
const privateBandiRouteRoute = privateBandiRouteRouteImport.update({
            id: '/bandi',path: '/bandi',getParentRoute: () => privateRouteRoute
          })
const privateBandoRouteRoute = privateBandoRouteRouteImport.update({
            id: '/bando',path: '/bando',getParentRoute: () => privateRouteRoute
          })
const privateEmailTextsRouteRoute = privateEmailTextsRouteRouteImport.update({
            id: '/email-texts',path: '/email-texts',getParentRoute: () => privateRouteRoute
          })
const privateExportsRouteRoute = privateExportsRouteRouteImport.update({
            id: '/exports',path: '/exports',getParentRoute: () => privateRouteRoute
          })
const privateInviiRouteRoute = privateInviiRouteRouteImport.update({
            id: '/invii',path: '/invii',getParentRoute: () => privateRouteRoute
          })
const privateResidencesRouteRoute = privateResidencesRouteRouteImport.update({
            id: '/residences',path: '/residences',getParentRoute: () => privateRouteRoute
          })
const privateStruttureRouteRoute = privateStruttureRouteRouteImport.update({
            id: '/strutture',path: '/strutture',getParentRoute: () => privateRouteRoute
          })
const privateUsersRouteRoute = privateUsersRouteRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => privateRouteRoute
          })
const authAcceptInviteIndexRoute = authAcceptInviteIndexRouteImport.update({
            id: '/accept-invite/',path: '/accept-invite/',getParentRoute: () => authRouteRoute
          })
const authForgotPasswordIndexRoute = authForgotPasswordIndexRouteImport.update({
            id: '/forgot-password/',path: '/forgot-password/',getParentRoute: () => authRouteRoute
          })
const authLoginIndexRoute = authLoginIndexRouteImport.update({
            id: '/login/',path: '/login/',getParentRoute: () => authRouteRoute
          })
const authResetPasswordIndexRoute = authResetPasswordIndexRouteImport.update({
            id: '/reset-password/',path: '/reset-password/',getParentRoute: () => authRouteRoute
          })
const privateAdminsIndexRoute = privateAdminsIndexRouteImport.update({
            id: '/admins/',path: '/admins/',getParentRoute: () => privateRouteRoute
          })
const privateAssistenzaIndexRoute = privateAssistenzaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateAssistenzaRouteRoute
          })
const privateBandiIndexRoute = privateBandiIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateBandiRouteRoute
          })
const privateBandoIndexRoute = privateBandoIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateBandoRouteRoute
          })
const privateBandoResidenceIdRouteRoute = privateBandoResidenceIdRouteRouteImport.update({
            id: '/$residenceId',path: '/$residenceId',getParentRoute: () => privateBandoRouteRoute
          })
const privateEmailTextsIndexRoute = privateEmailTextsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateEmailTextsRouteRoute
          })
const privateExportsIndexRoute = privateExportsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateExportsRouteRoute
          })
const privateInviiIndexRoute = privateInviiIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateInviiRouteRoute
          })
const privateProfileIndexRoute = privateProfileIndexRouteImport.update({
            id: '/profile/',path: '/profile/',getParentRoute: () => privateRouteRoute
          })
const privateResidencesIndexRoute = privateResidencesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateResidencesRouteRoute
          })
const privateStruttureIndexRoute = privateStruttureIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateStruttureRouteRoute
          })
const privateStruttureResidenceIdRouteRoute = privateStruttureResidenceIdRouteRouteImport.update({
            id: '/$residenceId',path: '/$residenceId',getParentRoute: () => privateStruttureRouteRoute
          })
const privateUsersIndexRoute = privateUsersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateUsersRouteRoute
          })
const privateAssistenzaUserIdIndexRoute = privateAssistenzaUserIdIndexRouteImport.update({
            id: '/$userId/',path: '/$userId/',getParentRoute: () => privateAssistenzaRouteRoute
          })
const privateBandoResidenceIdIndexRoute = privateBandoResidenceIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateBandoResidenceIdRouteRoute
          })
const privateBandoResidenceIdAttivitaRouteRoute = privateBandoResidenceIdAttivitaRouteRouteImport.update({
            id: '/attivita',path: '/attivita',getParentRoute: () => privateBandoResidenceIdRouteRoute
          })
const privateBandoResidenceIdDomandeRouteRoute = privateBandoResidenceIdDomandeRouteRouteImport.update({
            id: '/domande',path: '/domande',getParentRoute: () => privateBandoResidenceIdRouteRoute
          })
const privateBandoResidenceIdGraduatoriaRouteRoute = privateBandoResidenceIdGraduatoriaRouteRouteImport.update({
            id: '/graduatoria',path: '/graduatoria',getParentRoute: () => privateBandoResidenceIdRouteRoute
          })
const privateBandoResidenceIdOfferteRouteRoute = privateBandoResidenceIdOfferteRouteRouteImport.update({
            id: '/offerte',path: '/offerte',getParentRoute: () => privateBandoResidenceIdRouteRoute
          })
const privateBandoResidenceIdSegnalazioniRouteRoute = privateBandoResidenceIdSegnalazioniRouteRouteImport.update({
            id: '/segnalazioni',path: '/segnalazioni',getParentRoute: () => privateBandoResidenceIdRouteRoute
          })
const privateBandoResidenceIdVerificheRouteRoute = privateBandoResidenceIdVerificheRouteRouteImport.update({
            id: '/verifiche',path: '/verifiche',getParentRoute: () => privateBandoResidenceIdRouteRoute
          })
const privateEmailTextsCodeIndexRoute = privateEmailTextsCodeIndexRouteImport.update({
            id: '/$code/',path: '/$code/',getParentRoute: () => privateEmailTextsRouteRoute
          })
const privateExportsIdIndexRoute = privateExportsIdIndexRouteImport.update({
            id: '/$id/',path: '/$id/',getParentRoute: () => privateExportsRouteRoute
          })
const privateInviiAnomalyIdIndexRoute = privateInviiAnomalyIdIndexRouteImport.update({
            id: '/$anomalyId/',path: '/$anomalyId/',getParentRoute: () => privateInviiRouteRoute
          })
const privateResidencesResidenceIdIndexRoute = privateResidencesResidenceIdIndexRouteImport.update({
            id: '/$residenceId/',path: '/$residenceId/',getParentRoute: () => privateResidencesRouteRoute
          })
const privateResidencesNewIndexRoute = privateResidencesNewIndexRouteImport.update({
            id: '/new/',path: '/new/',getParentRoute: () => privateResidencesRouteRoute
          })
const privateStruttureResidenceIdIndexRoute = privateStruttureResidenceIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateStruttureResidenceIdRouteRoute
          })
const privateUsersUserIdIndexRoute = privateUsersUserIdIndexRouteImport.update({
            id: '/$userId/',path: '/$userId/',getParentRoute: () => privateUsersRouteRoute
          })
const privateBandiResidenceIdClassificaIndexRoute = privateBandiResidenceIdClassificaIndexRouteImport.update({
            id: '/$residenceId/classifica/',path: '/$residenceId/classifica/',getParentRoute: () => privateBandiRouteRoute
          })
const privateBandiResidenceIdQuotaDsuIndexRoute = privateBandiResidenceIdQuotaDsuIndexRouteImport.update({
            id: '/$residenceId/quota-dsu/',path: '/$residenceId/quota-dsu/',getParentRoute: () => privateBandiRouteRoute
          })
const privateBandoResidenceIdAttivitaIndexRoute = privateBandoResidenceIdAttivitaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateBandoResidenceIdAttivitaRouteRoute
          })
const privateBandoResidenceIdDomandeIndexRoute = privateBandoResidenceIdDomandeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateBandoResidenceIdDomandeRouteRoute
          })
const privateBandoResidenceIdDomandeSubmissionIdRouteRoute = privateBandoResidenceIdDomandeSubmissionIdRouteRouteImport.update({
            id: '/$submissionId',path: '/$submissionId',getParentRoute: () => privateBandoResidenceIdDomandeRouteRoute
          })
const privateBandoResidenceIdGraduatoriaIndexRoute = privateBandoResidenceIdGraduatoriaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateBandoResidenceIdGraduatoriaRouteRoute
          })
const privateBandoResidenceIdGraduatoriaSegnalazioniRouteRoute = privateBandoResidenceIdGraduatoriaSegnalazioniRouteRouteImport.update({
            id: '/segnalazioni',path: '/segnalazioni',getParentRoute: () => privateBandoResidenceIdGraduatoriaRouteRoute
          })
const privateBandoResidenceIdIngressiIndexRoute = privateBandoResidenceIdIngressiIndexRouteImport.update({
            id: '/ingressi/',path: '/ingressi/',getParentRoute: () => privateBandoResidenceIdRouteRoute
          })
const privateBandoResidenceIdOfferteIndexRoute = privateBandoResidenceIdOfferteIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateBandoResidenceIdOfferteRouteRoute
          })
const privateBandoResidenceIdQuotaDsuIndexRoute = privateBandoResidenceIdQuotaDsuIndexRouteImport.update({
            id: '/quota-dsu/',path: '/quota-dsu/',getParentRoute: () => privateBandoResidenceIdRouteRoute
          })
const privateBandoResidenceIdSegnalazioniIndexRoute = privateBandoResidenceIdSegnalazioniIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateBandoResidenceIdSegnalazioniRouteRoute
          })
const privateBandoResidenceIdVerificheIndexRoute = privateBandoResidenceIdVerificheIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateBandoResidenceIdVerificheRouteRoute
          })
const privateBandoResidenceIdAttivitaQuotaDsuIndexRoute = privateBandoResidenceIdAttivitaQuotaDsuIndexRouteImport.update({
            id: '/quota-dsu/',path: '/quota-dsu/',getParentRoute: () => privateBandoResidenceIdAttivitaRouteRoute
          })
const privateBandoResidenceIdDomandeSubmissionIdIndexRoute = privateBandoResidenceIdDomandeSubmissionIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateBandoResidenceIdDomandeSubmissionIdRouteRoute
          })
const privateBandoResidenceIdDomandeCaricaIndexRoute = privateBandoResidenceIdDomandeCaricaIndexRouteImport.update({
            id: '/carica/',path: '/carica/',getParentRoute: () => privateBandoResidenceIdDomandeRouteRoute
          })
const privateBandoResidenceIdGraduatoriaSegnalazioniIndexRoute = privateBandoResidenceIdGraduatoriaSegnalazioniIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateBandoResidenceIdGraduatoriaSegnalazioniRouteRoute
          })
const privateBandoResidenceIdOfferteDecadenzeIndexRoute = privateBandoResidenceIdOfferteDecadenzeIndexRouteImport.update({
            id: '/decadenze/',path: '/decadenze/',getParentRoute: () => privateBandoResidenceIdOfferteRouteRoute
          })
const privateBandoResidenceIdSegnalazioniFlagIdIndexRoute = privateBandoResidenceIdSegnalazioniFlagIdIndexRouteImport.update({
            id: '/$flagId/',path: '/$flagId/',getParentRoute: () => privateBandoResidenceIdSegnalazioniRouteRoute
          })
const privateBandoResidenceIdVerificheVerificationIdIndexRoute = privateBandoResidenceIdVerificheVerificationIdIndexRouteImport.update({
            id: '/$verificationId/',path: '/$verificationId/',getParentRoute: () => privateBandoResidenceIdVerificheRouteRoute
          })
const privateBandoResidenceIdDomandeSubmissionIdCorreggiIndexRoute = privateBandoResidenceIdDomandeSubmissionIdCorreggiIndexRouteImport.update({
            id: '/correggi/',path: '/correggi/',getParentRoute: () => privateBandoResidenceIdDomandeSubmissionIdRouteRoute
          })
const privateBandoResidenceIdGraduatoriaSegnalazioniReportIdIndexRoute = privateBandoResidenceIdGraduatoriaSegnalazioniReportIdIndexRouteImport.update({
            id: '/$reportId/',path: '/$reportId/',getParentRoute: () => privateBandoResidenceIdGraduatoriaSegnalazioniRouteRoute
          })





const authRouteRouteChildren = {
  authAcceptInviteIndexRoute: authAcceptInviteIndexRoute,authForgotPasswordIndexRoute: authForgotPasswordIndexRoute,authLoginIndexRoute: authLoginIndexRoute,authResetPasswordIndexRoute: authResetPasswordIndexRoute
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(authRouteRouteChildren)




const privateAssistenzaRouteRouteChildren = {
  privateAssistenzaIndexRoute: privateAssistenzaIndexRoute,privateAssistenzaUserIdIndexRoute: privateAssistenzaUserIdIndexRoute
}

const privateAssistenzaRouteRouteWithChildren = privateAssistenzaRouteRoute._addFileChildren(privateAssistenzaRouteRouteChildren)




const privateBandiRouteRouteChildren = {
  privateBandiIndexRoute: privateBandiIndexRoute,privateBandiResidenceIdClassificaIndexRoute: privateBandiResidenceIdClassificaIndexRoute,privateBandiResidenceIdQuotaDsuIndexRoute: privateBandiResidenceIdQuotaDsuIndexRoute
}

const privateBandiRouteRouteWithChildren = privateBandiRouteRoute._addFileChildren(privateBandiRouteRouteChildren)




const privateBandoResidenceIdAttivitaRouteRouteChildren = {
  privateBandoResidenceIdAttivitaIndexRoute: privateBandoResidenceIdAttivitaIndexRoute,privateBandoResidenceIdAttivitaQuotaDsuIndexRoute: privateBandoResidenceIdAttivitaQuotaDsuIndexRoute
}

const privateBandoResidenceIdAttivitaRouteRouteWithChildren = privateBandoResidenceIdAttivitaRouteRoute._addFileChildren(privateBandoResidenceIdAttivitaRouteRouteChildren)




const privateBandoResidenceIdDomandeSubmissionIdRouteRouteChildren = {
  privateBandoResidenceIdDomandeSubmissionIdIndexRoute: privateBandoResidenceIdDomandeSubmissionIdIndexRoute,privateBandoResidenceIdDomandeSubmissionIdCorreggiIndexRoute: privateBandoResidenceIdDomandeSubmissionIdCorreggiIndexRoute
}

const privateBandoResidenceIdDomandeSubmissionIdRouteRouteWithChildren = privateBandoResidenceIdDomandeSubmissionIdRouteRoute._addFileChildren(privateBandoResidenceIdDomandeSubmissionIdRouteRouteChildren)



const privateBandoResidenceIdDomandeRouteRouteChildren = {
  privateBandoResidenceIdDomandeSubmissionIdRouteRoute: privateBandoResidenceIdDomandeSubmissionIdRouteRouteWithChildren,privateBandoResidenceIdDomandeIndexRoute: privateBandoResidenceIdDomandeIndexRoute,privateBandoResidenceIdDomandeCaricaIndexRoute: privateBandoResidenceIdDomandeCaricaIndexRoute
}

const privateBandoResidenceIdDomandeRouteRouteWithChildren = privateBandoResidenceIdDomandeRouteRoute._addFileChildren(privateBandoResidenceIdDomandeRouteRouteChildren)




const privateBandoResidenceIdGraduatoriaSegnalazioniRouteRouteChildren = {
  privateBandoResidenceIdGraduatoriaSegnalazioniIndexRoute: privateBandoResidenceIdGraduatoriaSegnalazioniIndexRoute,privateBandoResidenceIdGraduatoriaSegnalazioniReportIdIndexRoute: privateBandoResidenceIdGraduatoriaSegnalazioniReportIdIndexRoute
}

const privateBandoResidenceIdGraduatoriaSegnalazioniRouteRouteWithChildren = privateBandoResidenceIdGraduatoriaSegnalazioniRouteRoute._addFileChildren(privateBandoResidenceIdGraduatoriaSegnalazioniRouteRouteChildren)



const privateBandoResidenceIdGraduatoriaRouteRouteChildren = {
  privateBandoResidenceIdGraduatoriaSegnalazioniRouteRoute: privateBandoResidenceIdGraduatoriaSegnalazioniRouteRouteWithChildren,privateBandoResidenceIdGraduatoriaIndexRoute: privateBandoResidenceIdGraduatoriaIndexRoute
}

const privateBandoResidenceIdGraduatoriaRouteRouteWithChildren = privateBandoResidenceIdGraduatoriaRouteRoute._addFileChildren(privateBandoResidenceIdGraduatoriaRouteRouteChildren)




const privateBandoResidenceIdOfferteRouteRouteChildren = {
  privateBandoResidenceIdOfferteIndexRoute: privateBandoResidenceIdOfferteIndexRoute,privateBandoResidenceIdOfferteDecadenzeIndexRoute: privateBandoResidenceIdOfferteDecadenzeIndexRoute
}

const privateBandoResidenceIdOfferteRouteRouteWithChildren = privateBandoResidenceIdOfferteRouteRoute._addFileChildren(privateBandoResidenceIdOfferteRouteRouteChildren)




const privateBandoResidenceIdSegnalazioniRouteRouteChildren = {
  privateBandoResidenceIdSegnalazioniIndexRoute: privateBandoResidenceIdSegnalazioniIndexRoute,privateBandoResidenceIdSegnalazioniFlagIdIndexRoute: privateBandoResidenceIdSegnalazioniFlagIdIndexRoute
}

const privateBandoResidenceIdSegnalazioniRouteRouteWithChildren = privateBandoResidenceIdSegnalazioniRouteRoute._addFileChildren(privateBandoResidenceIdSegnalazioniRouteRouteChildren)




const privateBandoResidenceIdVerificheRouteRouteChildren = {
  privateBandoResidenceIdVerificheIndexRoute: privateBandoResidenceIdVerificheIndexRoute,privateBandoResidenceIdVerificheVerificationIdIndexRoute: privateBandoResidenceIdVerificheVerificationIdIndexRoute
}

const privateBandoResidenceIdVerificheRouteRouteWithChildren = privateBandoResidenceIdVerificheRouteRoute._addFileChildren(privateBandoResidenceIdVerificheRouteRouteChildren)



const privateBandoResidenceIdRouteRouteChildren = {
  privateBandoResidenceIdAttivitaRouteRoute: privateBandoResidenceIdAttivitaRouteRouteWithChildren,privateBandoResidenceIdDomandeRouteRoute: privateBandoResidenceIdDomandeRouteRouteWithChildren,privateBandoResidenceIdGraduatoriaRouteRoute: privateBandoResidenceIdGraduatoriaRouteRouteWithChildren,privateBandoResidenceIdOfferteRouteRoute: privateBandoResidenceIdOfferteRouteRouteWithChildren,privateBandoResidenceIdSegnalazioniRouteRoute: privateBandoResidenceIdSegnalazioniRouteRouteWithChildren,privateBandoResidenceIdVerificheRouteRoute: privateBandoResidenceIdVerificheRouteRouteWithChildren,privateBandoResidenceIdIndexRoute: privateBandoResidenceIdIndexRoute,privateBandoResidenceIdIngressiIndexRoute: privateBandoResidenceIdIngressiIndexRoute,privateBandoResidenceIdQuotaDsuIndexRoute: privateBandoResidenceIdQuotaDsuIndexRoute
}

const privateBandoResidenceIdRouteRouteWithChildren = privateBandoResidenceIdRouteRoute._addFileChildren(privateBandoResidenceIdRouteRouteChildren)



const privateBandoRouteRouteChildren = {
  privateBandoResidenceIdRouteRoute: privateBandoResidenceIdRouteRouteWithChildren,privateBandoIndexRoute: privateBandoIndexRoute
}

const privateBandoRouteRouteWithChildren = privateBandoRouteRoute._addFileChildren(privateBandoRouteRouteChildren)




const privateEmailTextsRouteRouteChildren = {
  privateEmailTextsIndexRoute: privateEmailTextsIndexRoute,privateEmailTextsCodeIndexRoute: privateEmailTextsCodeIndexRoute
}

const privateEmailTextsRouteRouteWithChildren = privateEmailTextsRouteRoute._addFileChildren(privateEmailTextsRouteRouteChildren)




const privateExportsRouteRouteChildren = {
  privateExportsIndexRoute: privateExportsIndexRoute,privateExportsIdIndexRoute: privateExportsIdIndexRoute
}

const privateExportsRouteRouteWithChildren = privateExportsRouteRoute._addFileChildren(privateExportsRouteRouteChildren)




const privateInviiRouteRouteChildren = {
  privateInviiIndexRoute: privateInviiIndexRoute,privateInviiAnomalyIdIndexRoute: privateInviiAnomalyIdIndexRoute
}

const privateInviiRouteRouteWithChildren = privateInviiRouteRoute._addFileChildren(privateInviiRouteRouteChildren)




const privateResidencesRouteRouteChildren = {
  privateResidencesIndexRoute: privateResidencesIndexRoute,privateResidencesResidenceIdIndexRoute: privateResidencesResidenceIdIndexRoute,privateResidencesNewIndexRoute: privateResidencesNewIndexRoute
}

const privateResidencesRouteRouteWithChildren = privateResidencesRouteRoute._addFileChildren(privateResidencesRouteRouteChildren)




const privateStruttureResidenceIdRouteRouteChildren = {
  privateStruttureResidenceIdIndexRoute: privateStruttureResidenceIdIndexRoute
}

const privateStruttureResidenceIdRouteRouteWithChildren = privateStruttureResidenceIdRouteRoute._addFileChildren(privateStruttureResidenceIdRouteRouteChildren)



const privateStruttureRouteRouteChildren = {
  privateStruttureResidenceIdRouteRoute: privateStruttureResidenceIdRouteRouteWithChildren,privateStruttureIndexRoute: privateStruttureIndexRoute
}

const privateStruttureRouteRouteWithChildren = privateStruttureRouteRoute._addFileChildren(privateStruttureRouteRouteChildren)




const privateUsersRouteRouteChildren = {
  privateUsersIndexRoute: privateUsersIndexRoute,privateUsersUserIdIndexRoute: privateUsersUserIdIndexRoute
}

const privateUsersRouteRouteWithChildren = privateUsersRouteRoute._addFileChildren(privateUsersRouteRouteChildren)



const privateRouteRouteChildren = {
  privateAssistenzaRouteRoute: privateAssistenzaRouteRouteWithChildren,privateBandiRouteRoute: privateBandiRouteRouteWithChildren,privateBandoRouteRoute: privateBandoRouteRouteWithChildren,privateEmailTextsRouteRoute: privateEmailTextsRouteRouteWithChildren,privateExportsRouteRoute: privateExportsRouteRouteWithChildren,privateInviiRouteRoute: privateInviiRouteRouteWithChildren,privateResidencesRouteRoute: privateResidencesRouteRouteWithChildren,privateStruttureRouteRoute: privateStruttureRouteRouteWithChildren,privateUsersRouteRoute: privateUsersRouteRouteWithChildren,privateIndexRoute: privateIndexRoute,privateAdminsIndexRoute: privateAdminsIndexRoute,privateProfileIndexRoute: privateProfileIndexRoute
}

const privateRouteRouteWithChildren = privateRouteRoute._addFileChildren(privateRouteRouteChildren)

const rootRouteChildren = {
  authRouteRoute: authRouteRouteWithChildren,privateRouteRoute: privateRouteRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)